import React from 'react';
import {
  Box,
} from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import PlayerCardLink from '../../cards/playerCardLink';
import { League, Team, Player, TagType } from '../../../sdk/model';
import { toSalary } from '../../util/SalaryDisplay';
import RookieOptionTagButton from '../team/RookieOptionTagButton';
import RemoveTagButton from '../team/RemoveTagButton';

interface RookieOptionTaggingViewProps {
  league: League,
  team: Team,
  myTeam: boolean,
  playerMap: Map<string | undefined, Player | undefined>
}

function RookieOptionTaggingView(props: RookieOptionTaggingViewProps) {
  const [playerSelection, setPlayerSelection] = React.useState({});
    
    const columns = [
      {
        accessorKey: 'player.abbr_name',
        id: 'player',
        header: 'Player',
        minSize: 15,
        size: 15,
        Cell: ({ row }) => 
          <PlayerCardLink player={row.original.player} leagueId={props.league.id!} />
      },
      {
        accessorKey: 'tagged',
        id: 'tagged',
        header: 'Marked for Tag?',
        minSize: 15,
        size: 15,
      },
      {
        accessorKey: 'previousYearSalary',
        id: 'previousYearSalary',
        header: (props.league.currentSeasonYear! - 1) + ' Salary',
        minSize: 15,
        size: 15,
        Cell: ({ renderedCellValue, row }) => renderedCellValue ? toSalary(renderedCellValue) : '-'
      },
      {
        accessorKey: 'cost',
        header: 'Tag Cost',
        id: 'cost',
        size: 75,
        Cell: ({ renderedCellValue, row }) => toSalary(renderedCellValue)
      }
    ]
    
  const eligiblePlayers = Object.values(props.team.playerRoster!)
        .flatMap(playerGroup => playerGroup)
        .filter(player => player && player.contract?.rookieDraftRound === 1 && (player.contract.markedTagForNextContract === TagType.RookieOption ||
          (player.contract.seasons![player.contract.seasons!.length - 1].season_year === props.league.currentSeasonYear &&
          !player.contract.tag)));
 
  const teamPlayerMap = new Map(eligiblePlayers.map(teamPlayer => [teamPlayer.playerId, teamPlayer]));
   
  const data = eligiblePlayers.map(teamPlayer => {
    const player = props.playerMap.get(teamPlayer.playerId!)!;
    const previousContractValue = teamPlayer.contract!.seasons!
            .filter(season => season?.season_year === props.league.currentSeasonYear!- 1)[0]?.annual_salary!;
    const cost = props.league.currentSeason!.minimumTagValuesAtPosition![player.position!].rookieOption!;
    return {
      player: player, 
      tagged: teamPlayer.contract?.tag === TagType.Franchise ? "Finalized" : teamPlayer.contract?.markedTagForNextContract ? "Yes" : "No",
      teamPlayer: teamPlayer,
      previousYearSalary: previousContractValue,
      cost: cost
    }
  })
        
  const selectedTeamPlayer = Object.keys(playerSelection).length > 0 ?
        teamPlayerMap.get(Object.keys(playerSelection)[0]) : undefined;
    const selectedPlayer = selectedTeamPlayer ? props.playerMap.get(selectedTeamPlayer.playerId!)! : undefined;
    const table = useMaterialReactTable({
        columns,
        data,
        enablePagination: false,
        getRowId: (row) => row.player?.id!,
        enableRowSelection: props.myTeam,
        enableMultiRowSelection: false,
        onRowSelectionChange: setPlayerSelection,
        initialState: {
          sorting: [
            {
              id: "tagged",
              desc: true,
            },
            {
              id: "cost",
              desc: true,
            },
            {
              id: "previousYearSalary",
              desc: true,
            },
          ],
        },
        state: {
          rowSelection : playerSelection,
        }
      });
    return <Box>
      <br/>
      {!!selectedTeamPlayer && 
        (selectedTeamPlayer.contract?.markedTagForNextContract ? 
          <React.Fragment>
            <RemoveTagButton league={props.league} player={selectedPlayer!} tagType={TagType.RookieOption} callback={() => setPlayerSelection({})} />
          </React.Fragment> :
        <RookieOptionTagButton leagueId={props.league.id!} player={selectedPlayer!} contract={selectedTeamPlayer?.contract!} currentSeasonYear={props.league.currentSeasonYear!} team={props.team} callback={() => setPlayerSelection({})} />
      )}
      <MaterialReactTable table={table} />
    </Box>
}

export default RookieOptionTaggingView;
